<template>
  <div class="the-navbar__user-meta flex items-center" v-if="currentUser.name">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ currentUser.name }}</p>
      <small>Cấp độ {{currentUser.role[0]}}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <vs-avatar :text="currentUser.name"/>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Thoát</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {

    }
  },
  computed:{
        ...mapGetters([
            'currentUser'
        ])
    },
  methods: {
    logout() {
        this.$http.post("logout").then((res) => {}).catch(() => {});
        this.$store.dispatch("logout");
    },
  }
}
</script>
